import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatVal } from '../../../../../helpers/value'
import { selectTotalCompaniesQuantity } from '../store/slice'

export const TopCompaniesQuantity = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const totalCompaniesQuantity = useSelector(selectTotalCompaniesQuantity)

  return (
    <Translate
      value="industryOverview.QUANTITY_COMPANIES"
      quantity={formatVal(totalCompaniesQuantity, locale, false, 0)}
    />
  )
}
